import ACMissingContentError from 'academy-common-lib/components/error/ACMissingContentError';
import ExamScreen from '../features/exams/components/Exam';
import LinkContentContainer from './LinkContentContainer';
import ChapterContainer from './Chapter/ChapterContainer';
import { PracticalExerciseContainer } from '../features/practicalExercise/components/PracticalExercise';
import { VideoPlayerWithControls } from '../features/video';
import Quiz from '../features/quiz/components/Quiz';
import { usePageTitle } from '../hooks/usePageTitle';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoContent = ({
  content: {
    id: contentId,
    language
  },
  track,
  lesson,
  onFinish
}) => /*#__PURE__*/_jsx(VideoPlayerWithControls, {
  contentId: contentId.toString(),
  language: language,
  lessonId: lesson === null || lesson === void 0 ? void 0 : lesson.id.toString(),
  lessonName: lesson === null || lesson === void 0 ? void 0 : lesson.name,
  onFinish: onFinish,
  trackId: track === null || track === void 0 ? void 0 : track.id,
  trackName: track === null || track === void 0 ? void 0 : track.name
});
const StoredContentContainer = props => {
  const {
    content: {
      id: contentId,
      name: contentName,
      contentType
    }
  } = props;
  usePageTitle({
    i18nKey: 'learningCenter.dynamicPageTitles.lessonContent',
    options: {
      contentName
    },
    skip: !contentName
  });
  let ChildComponent = () => null;
  switch (contentType) {
    case 'VIDEO':
      ChildComponent = VideoContent;
      break;
    case 'CHAPTER':
      ChildComponent = ChapterContainer;
      break;
    case 'LINK':
      ChildComponent = LinkContentContainer;
      break;
    case 'PRACTICAL_EXERCISE_FLOW':
      ChildComponent = PracticalExerciseContainer;
      break;
    case 'QUIZ':
      ChildComponent = Quiz;
      break;
    case 'EXAM':
      ChildComponent = ExamScreen;
      break;
    default:
      return /*#__PURE__*/_jsx(ACMissingContentError, {});
  }
  return /*#__PURE__*/_jsx("div", {
    "data-contentid": contentId // used for testing
    ,
    "data-test-id": "stored-content-container",
    children: /*#__PURE__*/_jsx(ChildComponent, Object.assign({}, props))
  });
};
export default StoredContentContainer;